import { PinButton } from "../PinButton/PinButton";
import "./DashboardCardHeader.scss";

interface DashboardCardHeaderProps {
  title: string;
  isPinned: boolean;
  onPinClick: () => void;
  actions: React.ReactNode;
  showActions?: boolean;
}

export const DashboardCardHeader: React.FC<DashboardCardHeaderProps> = ({
  title,
  isPinned,
  onPinClick,
  actions,
  showActions = true,
}) => {
  return (
    <div className="dashboard-card-header">
      <h2 className="dashboard-card-header__title" data-testid="dashboard-card-title">
        {title}
      </h2>
      {showActions && (
        <div className="dashboard-card-header__actions">
          <PinButton isPinned={isPinned} onClick={onPinClick} />
          {actions}
        </div>
      )}
    </div>
  );
};
